import { Directive, OnInit, OnDestroy, Input, ViewContainerRef } from '@angular/core';
import { Validator } from '../core/model';
import { ValidatorBase } from '../core/model';

@Directive({
    selector: '[bank-account-validator]',
    host: { '(change)': 'changed($event)' },
    exportAs: 'validator'
})
export class BankAccountValidatorDirective extends ValidatorBase implements Validator, OnInit
{
    @Input('bank-account-validator')
    public getValue: () => string;

    @Input('accountPart')
    public accountPart: 'account-no' | 'reg-no' = 'account-no';

    private validateAccountPart: () => boolean;

    public constructor(viewRef: ViewContainerRef)
    {
        super(viewRef);
    }

    public ngOnInit(): void
    {
        if (this.accountPart === 'account-no')
        {
            this.validateAccountPart = this.validateAccountNo;
        } else if (this.accountPart === 'reg-no')
        {
            this.validateAccountPart = this.validateRegNo;
        }
    }

    public changed(): void
    {
        setTimeout(() =>
        {
            this.validate();
        }, 20);
    }

    protected isValid(): boolean
    {
        return this.validateAccountPart();
    }

    private validateRegNo(): boolean
    {
        return /^[0-9]{4}$/.test(this.elementRef.value);
    }

    private validateAccountNo(): boolean
    {
        return /^[0-9]{10}$/.test(this.elementRef.value);
    }


}
